import {
  useEffect, useMemo, useRef, useState,
} from 'react'
import { MagnifyingGlass } from '@Infowijs-eng/component-library/icons'
import TextInputWithAutoComplete from '../TextInputWithAutoComplete'
import useSomtodayInstitutes from '../../hooks/data/useSomtodayInstitutes'
import { SomtodayOrganisation } from '../../types'

interface ExporterSomtodaySetupProps {
  currentOrganisationId: string
  onSelectedOrganisation: (id: string) => void
}

export default function ExporterSomtodaySetup(
  {
    currentOrganisationId,
    onSelectedOrganisation,
  }: ExporterSomtodaySetupProps,
) {
  const [selectedOrganisation, setSelectedOrganisation] = useState<SomtodayOrganisation | undefined>(undefined)
  const [searchValue, setSearchValue] = useState('')
  const touched = useRef(false)

  const { data: institutes } = useSomtodayInstitutes()

  const mappedInstitutes = useMemo(() => institutes?.map((institute) => ({
    ...institute,
    key: institute.uuid,
    label: institute.naam,
  })), [institutes])

  const filteredInstitutes = useMemo(() => mappedInstitutes?.filter(
    (institute: { naam: string; brins: string[] }) => institute.naam.toLowerCase().includes(searchValue.toLowerCase())
      || institute.brins.find((brin: string) => brin.toLowerCase().includes(searchValue.toLowerCase())),
  ), [mappedInstitutes, searchValue])

  useEffect(() => {
    if (touched.current) return

    const existingLocation = mappedInstitutes?.find(({ uuid }) => uuid === currentOrganisationId)
    if (existingLocation) {
      setSelectedOrganisation(existingLocation)
      onSelectedOrganisation(existingLocation.id)
    }
  }, [currentOrganisationId, mappedInstitutes])

  return (
    <div>
      <div className="font-bold pb-2">Choose a school</div>
      <TextInputWithAutoComplete
        name="search institute"
        placeholder="Search for school name or BRIN"
        value={selectedOrganisation ? selectedOrganisation.naam : undefined}
        disabled={!!selectedOrganisation}
        onChange={(e) => !selectedOrganisation && setSearchValue(e.target.value)}
        autoCompleteResults={(filteredInstitutes && filteredInstitutes.length > 0) ? filteredInstitutes : null}
        onAutoCompleteSelect={(uuid) => {
          const selected = filteredInstitutes.find((item) => item.uuid === uuid)
          if (selected) {
            touched.current = true
            setSelectedOrganisation(selected)
            onSelectedOrganisation(selected.uuid)
          }
        }}
        onReset={() => {
          touched.current = true
          setSelectedOrganisation(undefined)
          onSelectedOrganisation(undefined)
        }}
        trailingAddon={<MagnifyingGlass className="text-[1.25rem] px-1" />}
      />
    </div>
  )
}
